// extracted by mini-css-extract-plugin
export var container = "_ac-0";
export var icon = "_ac-1";
export var text = "_ac-2";